/**
 * @file profile-context.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el contexto de la vista de perfil
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-07
 * @author DLTCode
 * @author Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import ProfileSkeleton from "@/components/ui/skeletons/common/ProfileSkeleton";
import { useSession } from "@/features/auth";
import { User } from "@/features/users";
import { createContext, PropsWithChildren, use, useEffect, useState } from "react";
import { ProfileViewConfig } from "./types";
type ProfileViewProviderProps = PropsWithChildren;
export const ProfileViewContext = createContext<ProfileViewConfig>(null!);
export function ProfileViewProvider(t0) {
  const $ = _c(16);
  const {
    children
  } = t0;
  const {
    data: userSession,
    status
  } = useSession();
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== status) {
    t1 = () => {
      if (status === "authenticated") {
        setIsInitialLoading(false);
      }
    };
    t2 = [status];
    $[0] = status;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (isInitialLoading) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ProfileSkeleton />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t3 = userSession as User;
  const t4 = userSession?.twoFactorCode || false;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsEditProfileModalOpen(true);
    t6 = () => setIsEditProfileModalOpen(false);
    t7 = () => setIsChangePasswordModalOpen(true);
    t8 = () => setIsChangePasswordModalOpen(false);
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] !== isChangePasswordModalOpen || $[9] !== isEditProfileModalOpen || $[10] !== t3 || $[11] !== t4) {
    t9 = {
      user: t3,
      isChecked: t4,
      isEditProfileModalOpen,
      isChangePasswordModalOpen,
      openEditProfileModal: t5,
      closeEditProfileModal: t6,
      openChangePasswordModal: t7,
      closeChangePasswordModal: t8
    };
    $[8] = isChangePasswordModalOpen;
    $[9] = isEditProfileModalOpen;
    $[10] = t3;
    $[11] = t4;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== children || $[14] !== t9) {
    t10 = <ProfileViewContext value={t9}>{children}</ProfileViewContext>;
    $[13] = children;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}
export function useProfileView() {
  const context = use(ProfileViewContext);
  if (!context) {
    throw new Error("useProfileView must be used within ProfileViewProvider");
  }
  return context;
}